'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var LINE_TYPE = exports.LINE_TYPE = 'LINE';
var LINE_DISPLAY_NAME = exports.LINE_DISPLAY_NAME = 'Line';

var LINE_EDGE_DND_TYPE = exports.LINE_EDGE_DND_TYPE = 'LINE_EDGE';
var LINE_CONTROL_POINT_DND_TYPE = exports.LINE_CONTROL_POINT_DND_TYPE = 'LINE_CONTROL_POINT';

var LINE_STYLE = exports.LINE_STYLE = {
    SOLID: 'SOLID',
    DASHED: 'DASHED'
};

var LINE_EDGE = exports.LINE_EDGE = {
    start: 'start',
    end: 'end'
};

var LINE_MARKER_STYLE = exports.LINE_MARKER_STYLE = {
    ARROW: 'ARROW',
    DOT: 'DOT',
    NONE: 'NONE'
};

var MIN_LINE_LENGTH = exports.MIN_LINE_LENGTH = 4;
var DEFAULT_LINE_WIDTH = exports.DEFAULT_LINE_WIDTH = 17;
var DEFAULT_LINE_HEIGHT = exports.DEFAULT_LINE_HEIGHT = DEFAULT_LINE_WIDTH;


//////////////////
// WEBPACK FOOTER
// ./src/common/lines/lineConstants.js
// module id = 57
// module chunks = 0